export default {
  data () {
    return {
      
    }
  },
  props: {
    title: String,
    selectDivWidth: String,
    justifyContent: String,
    labelWidth: String
  },
  mounted() {
    const selectDiv = document.querySelectorAll('.select-div')
    selectDiv.forEach(item => {
      item.style.width = this.selectDivWidth
    })
    const filterBox = document.querySelector('.filter')
    filterBox.style.justifyContent = this.justifyContent
    const labelBox = document.querySelectorAll('.filter-area-label')
    labelBox.forEach(item => {
      item.style.width = this.labelWidth
    })
  }
}


// WEBPACK FOOTER //
// ./src/common/js/filter_area.js